module.exports = __webpack_public_path__ + "Flag-512.dd04234bacb7874d973c220dd1f2da8c.svg";